import { FC, useCallback, useEffect, useState } from 'react'

import { NotificationMessage } from '~/src/components/shared/Notification/components/NotificationMessage'
import { Notification } from '~/src/components/shared/Notification/types'
import { getNotificationTimeLapsed } from '~/src/components/shared/Notification/helpers'
import { iconMap } from '~/src/components/shared/Notification/constants'

type Props = {
  notification: Notification
}

const NotificationContainer: FC<Props> = ({ notification }) => {
  const [timeLapsedSinceNotified, setTimeLapsedSinceNotified] = useState<
    string | undefined
  >(undefined)

  const getDifferenceWithCurrentTime = useCallback(() => {
    setTimeLapsedSinceNotified(getNotificationTimeLapsed(notification.timestamp))
  }, [notification.timestamp])

  useEffect(() => {
    getDifferenceWithCurrentTime()
  }, [getDifferenceWithCurrentTime])

  useEffect(() => {
    const interval = setInterval(() => {
      getDifferenceWithCurrentTime()
    }, 60000)

    return () => clearInterval(interval)
  }, [getDifferenceWithCurrentTime])

  return (
    <div className="flex items-center justify-start pl-6">
      <div data-testid={notification.tier.toString() + '-icon'}>
        {iconMap[notification.tier]}
      </div>
      <NotificationMessage
        displayType="dropdown"
        notification={notification}
        timeSinceNotified={timeLapsedSinceNotified}
      />
    </div>
  )
}

export default NotificationContainer
